var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShowEye(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "20px",
    viewBox: "0 0 27 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "show-eye") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-login-screen-show-password",
    transform: "translate(-316.000000, -285.000000)",
    fill: "#333333",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(23.000000, 270.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "show-eye",
    transform: "translate(293.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2992727,2.21677922 C6.47148052,2.21677922 0.387324675,9.31387013 0.131324675,9.61641558 C-0.0437922078,9.82254545 -0.0437922078,10.1250909 0.131324675,10.3323117 C0.28425974,10.5129351 2.52067532,13.1095065 5.74561039,15.1774545 L9.21880519,11.7042597 C8.99272727,11.1723117 8.86638961,10.5882597 8.86638961,9.97433766 C8.86638961,7.52961039 10.8545455,5.54145455 13.2992727,5.54145455 C13.9132468,5.54145455 14.4972468,5.66779221 15.0291948,5.89387013 L17.8850909,3.03797403 C16.4931429,2.54036364 14.9649351,2.21677922 13.2992727,2.21677922 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4993247,9.65849351 C26.3574545,9.45345455 24.0047273,6.14207792 20.0494545,4.00763636 L23.1114805,0.94561039 C23.3275844,0.729506494 23.3275844,0.378181818 23.1114805,0.162077922 C22.8953766,-0.054025974 22.5440519,-0.054025974 22.3279481,0.162077922 L3.48815584,19.001974 C3.27205195,19.2180779 3.27205195,19.5694026 3.48815584,19.7855065 C3.59563636,19.8941299 3.73750649,19.9484156 3.87937662,19.9484156 C4.02124675,19.9484156 4.16306494,19.8941299 4.27168831,19.7865974 L7.74597403,16.3123117 C9.45818182,17.1478961 11.3465974,17.7319481 13.2992727,17.7319481 C20.1270649,17.7319481 26.2112208,10.6348571 26.4672208,10.3323117 C26.6278961,10.1405714 26.6422857,9.86462338 26.4993247,9.65849351 Z M13.2992727,14.4072727 C12.2763636,14.4072727 11.3465974,14.0448831 10.5952208,13.461974 L16.7868571,7.27033766 C17.3697662,8.02171429 17.7321558,8.95153247 17.7321558,9.97438961 C17.7321558,12.4191169 15.744,14.4072727 13.2992727,14.4072727 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowEye);
export default __webpack_public_path__ + "static/media/show-eye.430de7679735814429c2b92a3ba30784.svg";
export { ForwardRef as ReactComponent };